import * as React from "react";
import { match } from "react-router-dom";
import TopBar from "./Ops.ApplicationStatusMessages.GeneralTopBar";
import StatusMessageCategories from "app/data/statusMessageCategories";

import { Select, FormControl, MenuItem, InputLabel } from "@material-ui/core";

import AllStatusMessagesContainer from "app/components/AppComponents/ApplicationsStatusMessages/AllStatusMessagesContainer";

const Categories = [
  {
    value: "",
    label: "Show all status messages",
  },
].concat(StatusMessageCategories);

type Props = {
  match: match<{ ref: string }>;
  setHeader: (data: { title: string; description: string }) => void;
};

type State = {
  category: string;
};

export default class List extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      category: "",
    };
  }
  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Application status messages",
      description: "Status messages",
    });
  }

  onActiveChange = (value: string) => {
    this.setState({
      category: value,
    });
  };

  render() {
    return (
      <>
        <TopBar />
        <section className="padded">
          <div
            style={{
              paddingBottom: "20px",
            }}
          >
            <FormControl>
              <InputLabel>Filter by category</InputLabel>
              <Select
                style={{ width: "300px", padding: "10px" }}
                value={this.state.category}
                onChange={(event) => this.onActiveChange(event.target.value)}
              >
                {Categories.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <AllStatusMessagesContainer
            name={"ops.application_status_messages.list"}
            order_by_category={true}
            filter_by_category={this.state.category}
          />
        </section>
      </>
    );
  }
}
